/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable arrow-body-style */
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';
import { setAlert } from '@/store/slices/alert';
import { closeModal } from '@/store/slices/modal';
import { handleApiError } from '@/utils/helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

const fetcher = (url: any, splitTableObj: any) => {
  const response = axios({
    method: 'post',
    url: `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.split_table`,
    data: { data: { ...splitTableObj } },
    withCredentials: true,
  })
    .then((data) => data)
    .catch((error) => error);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useSplitTable = () => {
  const { url } = useSelector(selectAuth);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleSuccess = () => {
    dispatch(
      setAlert({ type: 'success', message: 'Table spilted successfully' }),
    );

    dispatch(closeModal({ type: 'splitTable' }));

    navigate('/tables');
  };

  const handleError = (message: string) => {
    dispatch(setAlert({ type: 'error', message }));
  };

  const mutate = useMutation(
    (splitTableObj: any) => fetcher(url, splitTableObj),
    {
      onSettled: (data) => {
        if (!data.data) {
          const errorMessage = handleApiError(data);
          handleError(errorMessage);
        } else if (data.data) {
          handleSuccess();
          queryClient.invalidateQueries(['table-groups']);
        }
      },
      onError: () => handleError('An Error Occured. Contact Administration'),
    },
  );

  return mutate;
};
